import React from "react";
import { NavbarButton } from "./NavbarButton";
import styled from "@emotion/styled";
import { getNavbarButtonOptions } from "../NavbarV2Desktop";
import { GlobalStore } from "store/global/GlobalStore";

export const NavbarButtons: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <NavbarButtonsContainer>
      {getNavbarButtonOptions(theme).map(option => (
        <NavbarButton key={option.text} {...option} />
      ))}
    </NavbarButtonsContainer>
  );
};

// Sub-components

const NavbarButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  width: fit-content;
`;
